module.exports = __webpack_public_path__ + "static/media/pagi-next-page.eae00cbe.svg";